export default "__VITE_ASSET__BYoRe6Li__"